import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { apm } from "./apm";

export function ApmRouteTracker() {
  const location = useLocation();
  const hostname = window.location.hostname;
  const isLocalEnv = hostname === "localhost" || hostname === "127.0.0.1";

  useEffect(() => {
    if (isLocalEnv) {
      return;
    }
    const tx = apm.startTransaction(
      `${location.pathname}${location.search}`,
      "route-change"
    );

    const timer = window.setTimeout(() => {
      tx?.end();
    }, 0);

    return () => {
      window.clearTimeout(timer);
      tx?.end();
    };
  }, [location.pathname, location.search]);

  return null;
}